import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { CommentResponse } from '../../../../types/api/comments';
import { formatDateTime } from '../../../../helpers/dates';
import HighlightedText from '../../../basic/HighlightedText';
import { UserHeaderCard } from '../../../basic/UserHeaderCard';
import MediaPreview from '../../../common/MediaPreview';
import { Stack, Text, Checkbox, Button } from '@primer/react'
import { ClockIcon, TrashIcon, ReplyIcon } from '@primer/octicons-react';

interface AdsFaqCardProps {
    comment: CommentResponse;
    highlight: string | undefined
    isSelected: boolean
    isDisabled: boolean
    didSelected: (isSelected: boolean) => void
    didDelete: () => void
}

export const AdsFaqCard: React.FC<AdsFaqCardProps> = ({ comment, highlight, isSelected, isDisabled, didSelected, didDelete }) => {

    const navigate = useNavigate();

    const handleRowSelect = useCallback((rowId: string, isSelected: boolean) => {
        didSelected(isSelected)
    }, []);

    return (
        <div className="bg-header border border-border rounded-lg w-full mb-4">
            <div className="bg-white w-full rounded-t-lg border-b">
                <div className="p-4">
                    <Stack justify="space-between" direction="horizontal">
                        {comment.user && <UserHeaderCard
                            user={comment.user}
                            isLarge={false}
                            isSupport={false}
                            onClick={() => comment.user && navigate('/users/user?id=' + comment.user.id)} />}
                        <Checkbox
                            checked={isSelected}
                            disabled={isDisabled}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                handleRowSelect(comment.id, e.target.checked)
                            }
                            aria-label={`Выделить ${comment.content}`}
                        />
                    </Stack>
                </div>
            </div>
            <Stack gap='none' className='ml-4 mr-4 mt-4 mb-4'>
                <div className='border-b pb-3'>
                    <Text as="span" weight='medium' className='text-[14px]'>Вопрос</Text>
                    <div className='flex items-center justify-between'>
                        <HighlightedText text={comment.content} highlight={highlight ?? ''} />
                    </div>
                    {comment.media && <MediaPreview images={comment.media} className='mt-2' />}
                </div>

                {
                    comment.replies && comment.replies.map((comment, i) => (
                        <React.Fragment key={i}>
                            <div className="ml-6 mt-5">
                                <Stack direction="horizontal" gap="condensed" align="center">
                                    <ReplyIcon size={16} />
                                    <Text as="span" weight='medium' className='block text-[14px]'>Комментарий</Text>
                                </Stack>
                                <div className='flex items-center justify-between border-b pb-3'>
                                    <HighlightedText text={comment.content} highlight={highlight ?? ''} />
                                </div>
                            </div>
                        </React.Fragment>
                    ))
                }
            </Stack>

            <div className="bg-white w-full rounded-b-lg border-b">
                <div className="p-4">
                    <Stack direction="horizontal" justify="space-between" gap="condensed">
                        <Stack direction="horizontal" align="center" gap="condensed">
                            <ClockIcon size={16} />
                            <Text className='text-[14px] text-aloix-grey ml-1'>{formatDateTime(comment.createdAt)}</Text>
                        </Stack>
                        <Button
                            variant="danger"
                            leadingVisual={TrashIcon}
                            disabled={isSelected || isDisabled}
                            onClick={didDelete}>
                            Удалить
                        </Button>
                    </Stack>
                </div>
            </div>
        </div>
    )
};